export default "__VITE_ASSET__BvzAzw9K__"